import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { loadBlockReports } from "../../actions";
import _ from "lodash";
import styled from "styled-components";
import { Flex, Box } from "rebass";
import * as Icon from "react-feather";
import { BorderBottom } from "../../themes";

class BlockReport extends Component {
  componentWillMount() {
    this.props.loadBlockReports();
  }

  render() {
    const { blockReports } = this.props;
    const { items } = blockReports;

    if (items.length <= 0) {
      return (
        <div className="container">
          <header>
            <Icon.ArrowLeft
              style={{ paddingBottom: "6px" }}
              onClick={() => this.props.history.goBack()}
            />
            <h1 style={{ marginLeft: 8 }}>全体・ブロック効率速報</h1>
          </header>

          <div style={{ padding: 16 }}>現在準備中!</div>
        </div>
      );
    }
    return (
      <div className="container">
        <header>
          <Icon.ArrowLeft
            style={{ paddingBottom: "6px" }}
            onClick={() => this.props.history.goBack()}
          />
          <h1 style={{ marginLeft: 8 }}>全体・ブロック効率速報</h1>
        </header>

        <RankingList>
          {items.map((ranking, i) => {
            return (
              <RankingItem key={i}>
                <Flex justifyContent="space-between">
                  <Box width={1 / 2}>
                    <Rank>{ranking.rank}</Rank>
                    <Name>{ranking.blockName}</Name>
                  </Box>
                  <Box width={1 / 2} style={{ textAlign: "center" }}>
                    <Value>{ranking.estimatedNet}</Value> /
                    <Value>{ranking.totalNet}</Value>
                  </Box>
                </Flex>
              </RankingItem>
            );
          })}
        </RankingList>
      </div>
    );
  }
}

const RankingList = styled.ul``;

const RankingItem = styled.li`
  padding: 16px;
  ${BorderBottom}
`;

const Rank = styled.span`
  color: rgb(101, 119, 134);
  margin-right: 16px;
  float: left;
  font-weight: bold;
`;

const Name = styled.div`
  margin-left: 5px;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  width: 100%;
`;

const Value = styled.span`
  color: rgb(101, 119, 134);
  margin-left: 5px;
  text-align: center;
  font-weight: bold;
`;

function mapStateToProps(state) {
  return {
    blockReports: state.blockReports
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      loadBlockReports
    }
  )(BlockReport)
);
